import BaseComponent from "../../../common/js/components/base-component";

class CAppComponent extends BaseComponent {

    constructor(props) {
        super(props);
    }

}

export default CAppComponent ;
